/* RESPONSIBLE TEAM: team-ai-agent */
import type IntlService from 'ember-intl/services/intl';
import {
  and,
  funnelSeries,
} from 'embercom/components/reporting/bespoke/sdr-performance/qualification-funnel/series-config';

type RoutingOutcome = {
  identifier: string;
  title: string;
};

const filters = {
  get sdrParticipated() {
    return {
      type: 'category',
      data: {
        property: 'fin_sdr.participated',
        attribute: 'conversation.fin_sdr.participated',
        values: [true],
      },
    };
  },

  routingOutcome(outcomeTitle: string) {
    return {
      type: 'category',
      data: {
        property: 'fin_sdr.routing_outcome.title',
        attribute: 'conversation.fin_sdr.routing_outcome_title',
        values: [outcomeTitle],
      },
    };
  },

  get disengaged() {
    return {
      type: 'not_exists',
      data: {
        property: 'fin_sdr.routing_outcome.identifier',
        attribute: 'conversation.fin_sdr.routing_outcome_title',
      },
    };
  },
};

export const QualificationRatesConfig = {
  getChartSeries(intl: IntlService, outcome: RoutingOutcome) {
    let outcomeFilter =
      outcome.identifier === 'disengaged'
        ? filters.disengaged
        : filters.routingOutcome(outcome.title);

    let isDisengaged = outcome.identifier === 'disengaged';
    let rateLabel = isDisengaged
      ? intl.t('ai-agent.analyze.leads.disengaged-outcome-rate')
      : intl.t('ai-agent.analyze.leads.outcome-rate', { outcome: outcome.title });
    let countLabel = isDisengaged
      ? intl.t('ai-agent.analyze.leads.disengaged-prospects-count')
      : intl.t('ai-agent.analyze.leads.prospects-count', { outcome: outcome.title });

    return [
      funnelSeries(and(filters.sdrParticipated, outcomeFilter), rateLabel),
      funnelSeries(filters.sdrParticipated, countLabel),
    ];
  },
};
